var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.sticker.tts && _vm.sticker.tts.bounds)?_c('div',{staticClass:"base-image",class:[_vm.list && 'mt-1'],style:({ backgroundImage: `url(${_vm.stickerImageSrc})`, minHeight: `${_vm.stickerDimensions.baseHeight}px`, minWidth: `${_vm.stickerDimensions.baseWidth}px`, maxHeight: `${_vm.stickerDimensions.baseHeight}px`, maxWidth: `${_vm.stickerDimensions.baseWidth}px`, backgroundPosition: 'center center', backgroundSize: 'contain', backgroundRepeat: 'no-repeat', opacity: _vm.fade ? 0.5 : 1 })},[(_vm.sticker.tts.isEyeEnabled && _vm.sticker.tts.eyeImage && _vm.sticker.tts.bounds)?_c('div',{style:({
        position: 'absolute',
        width: '100%',
        height: '100%',
    })},[_c('div',{style:({
            position: 'absolute',
            backgroundImage: `url(${_vm.actions.getImage('eyes', _vm.sticker.tts.eyeImage)})`,
            backgroundSize: 'contain',
            backgroundPosition: 'center center',
            zIndex: 4,
            transform: _vm.sticker.tts.isEyeFlipped ? `rotate(${_vm.sticker.tts.position.eyeAngle}deg) scaleX(-1)` : `rotate(${_vm.sticker.tts.position.eyeAngle}deg) scaleX(1)`,
            left: `${((_vm.sticker.tts.bounds.eyeX / 250) * 100)}%`,
            top: `${(_vm.sticker.tts.bounds.eyeY / 300) * 100}%`,
            width: `${(_vm.sticker.tts.bounds.eyeW / 100) * _vm.stickerDimensions.percentX}px`,
            height: `${(_vm.sticker.tts.bounds.eyeH / 100) * _vm.stickerDimensions.percentY}px`,
        })})]):_vm._e(),(_vm.sticker.tts.isMouthEnabled && _vm.sticker.tts.mouthImage)?_c('div',{style:({
        position: 'absolute',
        width: '100%',
        height: '100%',
    })},[_c('div',{style:({
            position: 'absolute',
            backgroundImage: `url(${_vm.actions.getImage('mouth', _vm.sticker.tts.mouthImage)})`,
            backgroundSize: 'contain',
            backgroundPosition: 'center center',
            zIndex: 4,
            transform: _vm.sticker.tts.isMouthFlipped ? `rotate(${_vm.sticker.tts.position.mouthAngle}deg) scaleX(-1)` : `rotate(${_vm.sticker.tts.position.mouthAngle}deg) scaleX(1)`,
            left: `${((_vm.sticker.tts.bounds.mouthX / 250) * 100)}%`,
            top: `${(_vm.sticker.tts.bounds.mouthY / 300) * 100}%`,
            width: `${(_vm.sticker.tts.bounds.mouthW / 100) * _vm.stickerDimensions.percentX}px`,
            height: `${(_vm.sticker.tts.bounds.mouthH / 100) * _vm.stickerDimensions.percentY}px`,
        })})]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }